// The languages a survey can render its widget chrome in. Mirrors
// surveys-core's LANGUAGES (the server rejects anything else) and the
// widget's own packs in frontend/widget/src/i18n.ts — adding a language
// means all three.
//
// Labels are endonyms: the operator picking one is choosing the language
// their own guests read, so it should appear the way they write it.

export interface LanguageOption {
    code: string;
    label: string;
}

export const LANGUAGES: LanguageOption[] = [
    { code: "en", label: "English" },
    { code: "sv", label: "Svenska" },
    { code: "nb", label: "Norsk bokmål" },
    { code: "da", label: "Dansk" },
    { code: "fi", label: "Suomi" },
    { code: "de", label: "Deutsch" },
    { code: "fr", label: "Français" },
    { code: "es", label: "Español" },
    { code: "it", label: "Italiano" },
    { code: "nl", label: "Nederlands" },
];

export const DEFAULT_LANGUAGE = "en";

/** The endonym for a stored code, falling back to the code itself so a
 *  survey saved before a language was retired still names something. */
export function languageLabel(code: string): string {
    return LANGUAGES.find((language) => language.code === code)?.label ?? code;
}
